'use client';

import { useEffect, useState } from 'react';

/**
 * Atajos a las secciones del perfil (Precios, Trabajos, Horarios, Dónde). Marca la sección que se
 * está leyendo; arriba de todo, la primera.
 */
export default function ProfileTabs({ tabs }) {
  const [active, setActive] = useState(tabs[0]?.id);

  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return undefined;
    const targets = tabs.map((t) => document.getElementById(t.id)?.closest('section')).filter(Boolean);
    if (!targets.length) return undefined;
    const visible = new Map();
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) visible.set(entry.target, entry.isIntersecting);
        const current = targets.find((el) => visible.get(el));
        const id = current?.querySelector('h2')?.id;
        setActive(id || tabs[0].id);
      },
      // Cuenta la franja de arriba de la pantalla, debajo de la barra.
      { rootMargin: '-96px 0px -55% 0px' }
    );
    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [tabs]);

  return (
    <nav aria-label="Secciones del perfil" className="pf-tabs">
      {tabs.map((tab) => (
        <a
          key={tab.id}
          href={`#${tab.id}`}
          className={`pf-tab ${active === tab.id ? 'is-active' : ''}`}
          aria-current={active === tab.id ? 'true' : undefined}
        >
          {tab.label}
        </a>
      ))}
    </nav>
  );
}
